import React from 'react';
import { ProductType } from '../../../util/types';
import ProductPage from '../../../components/ProductPage/ProductPage';
import NotFoundPage from '../../../components/NotFoundPage/NotFoundPage';
import { product as productLabels } from '../../../mockdata';
import fetchProductData from '../../../axios/fetchProductData';

export default function SlugPage({
  data,
  locale,
  localeCountry,
}: {
  data: ProductType;
  locale?: string;
  localeCountry?: string;
}) {
  return !data ? (
    <NotFoundPage locale={locale || 'en'} />
  ) : (
    <ProductPage
      {...data}
      locale={locale || 'en'}
      localeCountry={localeCountry}
      labels={productLabels}
      backLink={{
        href: `/${localeCountry ? `/?locale_country=${localeCountry}` : ''}`,
        children: productLabels.back_to_list,
      }}
    />
  );
}

export const getServerSideProps = fetchProductData({ queryKey: 'product' });
